import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"
import utc from "dayjs/plugin/utc"
import "dayjs/locale/en" // 英文语言包

export function setupDayjs() {
  dayjs.extend(utc,)
  dayjs.extend(localizedFormat,)
  dayjs.locale("en",) // 设置为英文
}
